// extracted by mini-css-extract-plugin
export var close = "index-module--close--p-3n5";
export var controls = "index-module--controls--8GueP";
export var description = "index-module--description--zF49E";
export var image = "index-module--image--a3R0e";
export var imageWrap = "index-module--imageWrap--DIXy4";
export var lightboxContent = "index-module--lightboxContent--gsOc6";
export var lightboxModal = "index-module--lightboxModal--t-r2+";